import { HttpModule } from '@angular/http';
import { DataService } from './services/data.service';
import { GeneralService } from './services/general.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CaseStudiesComponent } from './case-studies/case-studies.component';
import { ClientsFeedbackTestimonialsComponent } from './clients-feedback-testimonials/clients-feedback-testimonials.component';
import { EngagementModelsComponent } from './engagement-models/engagement-models.component';
import { HowWeWorkComponent } from './how-we-work/how-we-work.component';
import { CtoForStartupsComponent } from './cto-for-startups/cto-for-startups.component';
import { WhyOutsourceOffshoreComponent } from './why-outsource-offshore/why-outsource-offshore.component';
import { QrushMobileAppComponent } from './qrush-mobile-app/qrush-mobile-app.component';
import { TracenowMobileAppComponent } from './tracenow-mobile-app/tracenow-mobile-app.component';
import { CustomSoftwareDevComponent } from './custom-software-dev/custom-software-dev.component';
import { DigitalMarketingAgencyComponent } from './digital-marketing-agency/digital-marketing-agency.component';
import { QualityAssuranceTestingComponent } from './quality-assurance-testing/quality-assurance-testing.component';
import { DatabaseDesignDevComponent } from './database-design-dev/database-design-dev.component';
import { CloudInfrastructureComponent } from './cloud-infrastructure/cloud-infrastructure.component';
import { EcommerceDevComponent } from './ecommerce-dev/ecommerce-dev.component';
import { WebApplicationDevComponent } from './web-application-dev/web-application-dev.component';
import { CmsWebDevComponent } from './cms-web-dev/cms-web-dev.component';
import { UiUxDesignServicesComponent } from './ui-ux-design-services/ui-ux-design-services.component';
import { EnterpriseSolutionsComponent } from './enterprise-solutions/enterprise-solutions.component';
import { WindowAppDevComponent } from './window-app-dev/window-app-dev.component';
import { AndroidAppDevComponent } from './android-app-dev/android-app-dev.component';
import { IpadAppDevComponent } from './ipad-app-dev/ipad-app-dev.component';
import { DotnetDevComponent } from './dotnet-dev/dotnet-dev.component';
import { Router, Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HeadMenuComponent } from './head-menu/head-menu.component';
import { FooterComponent } from './footer/footer.component';
import { MobileAppDevComponent } from './mobile-app-dev/mobile-app-dev.component';
import { IphoneAppDevComponent } from './iphone-app-dev/iphone-app-dev.component';
import { ClientLogoComponent } from './client-logo/client-logo.component';
import { CommonScriptComponent } from './common-script/common-script.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { SharepointDevComponent } from './sharepoint-dev/sharepoint-dev.component';
import { DotnetNukeDevComponent } from './dotnet-nuke-dev/dotnet-nuke-dev.component';
import { DynamicsCrmComponent } from './dynamics-crm/dynamics-crm.component';
import { WindowsMobileDevComponent } from './windows-mobile-dev/windows-mobile-dev.component';
import { HireLaravelDevComponent } from './hire-laravel-dev/hire-laravel-dev.component';
import { CustomCorePhpDevComponent } from './custom-core-php-dev/custom-core-php-dev.component';
import { HireCodeIgniterFrameworkDevComponent } from './hire-code-igniter-framework-dev/hire-code-igniter-framework-dev.component';
import { CustomWordpressDevComponent } from './custom-wordpress-dev/custom-wordpress-dev.component';
import { CustomMagentoDevComponent } from './custom-magento-dev/custom-magento-dev.component';
import { JavaWebDevComponent } from './java-web-dev/java-web-dev.component';
import { ColdfusionDevComponent } from './coldfusion-dev/coldfusion-dev.component';
import { CustomPythonOdooDevComponent } from './custom-python-odoo-dev/custom-python-odoo-dev.component';
import { HireFullMeanStackDevComponent } from './hire-full-mean-stack-dev/hire-full-mean-stack-dev.component';
import { HireLampStackDevComponent } from './hire-lamp-stack-dev/hire-lamp-stack-dev.component';
import { HireOdooDevComponent } from './hire-odoo-dev/hire-odoo-dev.component';
import { SalesforceCrmDevComponent } from './salesforce-crm-dev/salesforce-crm-dev.component';
import { SageCrmDevComponent } from './sage-crm-dev/sage-crm-dev.component';
import { VtigerCrmDevComponent } from './vtiger-crm-dev/vtiger-crm-dev.component';
import { SugarCrmDevComponent } from './sugar-crm-dev/sugar-crm-dev.component';
import { HireMsDynamicsDevComponent } from './hire-ms-dynamics-dev/hire-ms-dynamics-dev.component';
import { IosDevComponent } from './ios-dev/ios-dev.component';
import { AndroidDevComponent } from './android-dev/android-dev.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { CompanyOverviewComponent } from './company-overview/company-overview.component';
import { OffshoreDevComponent } from './offshore-dev/offshore-dev.component';
import { PartneringOffshoreDevComponent } from './partnering-offshore-dev/partnering-offshore-dev.component';
import { CareersComponent } from './careers/careers.component';
import { OrganizationalValuesComponent } from './organizational-values/organizational-values.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { LatwComponent } from './latw/latw.component';
import { TriptivaComponent } from './triptiva/triptiva.component';
import { IRemotePayComponent } from './i-remote-pay/i-remote-pay.component';
import { OdooPosDevComponent } from './odoo-pos-dev/odoo-pos-dev.component';
import { MetawallsComponent } from './metawalls/metawalls.component';
import { CoacherrComponent } from './coacherr/coacherr.component';
import { UiUxComponent } from './ui-ux/ui-ux.component';
import { HireMicrosoftDotnetDevComponent } from './hire-microsoft-dotnet-dev/hire-microsoft-dotnet-dev.component';
import { HireWordpressDevComponent } from './hire-wordpress-dev/hire-wordpress-dev.component';
import { HireMagentoDevComponent } from './hire-magento-dev/hire-magento-dev.component';
import { HireIosAppsDevComponent } from './hire-ios-apps-dev/hire-ios-apps-dev.component';
import { HireAndroidAppDevComponent } from './hire-android-app-dev/hire-android-app-dev.component';
import { HireJoomlaDevComponent } from './hire-joomla-dev/hire-joomla-dev.component';
import { HireSeoManagersComponent } from './hire-seo-managers/hire-seo-managers.component';
import { HirePhpDevComponent } from './hire-php-dev/hire-php-dev.component';
import { PopupInquiryComponent } from './popup-inquiry/popup-inquiry.component';
import { ErrorComponent } from './error/error.component';
import { InquireNowComponent } from './inquire-now/inquire-now.component';
import { ContactInquiryComponent } from './contact-inquiry/contact-inquiry.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';


const appRoutes: Routes = [
  //Home
  { path: '', component: HomeComponent, data: { title:'Web, Mobile App, CRM, vTiger & ODOO Development Company India | Veepal'}},
  
  //Services
  { path: 'mobile-app-development-india',component: MobileAppDevComponent, data: { title:'Best Mobile App Development Company | Hire Mobile App Developers | Veepal'}},
  { path: 'iphone-app-development-india',component: IphoneAppDevComponent, data: { title:'Hire iOS Developers | iPhone App Development Company India | Veepal'} },
  { path: 'ipad-app-development-india',component: IpadAppDevComponent, data: { title:'Hire iOS Developers | iPad App Development Company India | Veepal'} },
  { path: 'android-app-development-india',component: AndroidAppDevComponent, data: { title:'Custom Android App Development Company | Hire Android Developers | Veepal'} },
  { path: 'windows-mobile-application-development-india',component: WindowAppDevComponent, data: { title:'Windows Mobile Application Development India'} },
  { path: 'enterprise-solutions-india', component: EnterpriseSolutionsComponent, data: { title:'Enterprise Solutions India'} },
  
  { path: 'microsoft-dynamics-crm-development', component: HireMsDynamicsDevComponent, data: { title:'Microsoft Dynamics CRM Development & Integration | Veepal IT Services'} },
  { path: 'odoo-open-erp-crm-development', component: HireOdooDevComponent, data: { title:'Odoo Open ERP Development & Implementation India | Hire Odoo Developer'} },

  { path: 'ui-ux-design-services-india', component: UiUxDesignServicesComponent, data: { title:'UI/UX Design & Development Company | UI/UX Services India | Veepal'} },
  { path: 'cms-web-development-india', component: CmsWebDevComponent, data: { title:'Custom Website Development Company India | Hire Web Developer | Veepal'} },
  { path: 'web-application-development-india', component: WebApplicationDevComponent, data: { title:'Web Application Development India'} },
  { path: 'ecommerce-development-india', component: EcommerceDevComponent, data: { title:'E-Commerce Development India'} },
  { path: 'cloud-infrastructure-management', component: CloudInfrastructureComponent, data: { title:'CLOUD INFRASTRUCTURE MANAGEMENT'} },
  { path: 'database-design-development-india', component: DatabaseDesignDevComponent, data: { title:'Database Design &amp; Development India'} },
  { path: 'quality-assurance-testing-india', component: QualityAssuranceTestingComponent, data: { title:'Quality Assurance &amp; Testing'} },
  { path: 'digital-marketing-agency-india', component: DigitalMarketingAgencyComponent, data: { title:'Best Digital Marketing Agency India | Affordable SEO Packages | Veepal'} },
  { path: 'custom-software-development-india', component: CustomSoftwareDevComponent, data: { title:'Custom Software Development India | Veepal.com'} },

  //Technologies
  { path: 'dotnet-development-india', component: DotnetDevComponent, data: { title:'Custom ASP.NET Development Company India | Offshore .Net Development'} },
  { path: 'sharepoint-development-india', component: SharepointDevComponent, data: { title:'SharePoint Development Company India'} },
  { path: 'dotnet-nuke-development-india', component: DotnetNukeDevComponent, data: { title:'Custom DotNetNuke Development Company India | Hire DotNetNuke Developers'} },
  { path: 'windows-mobile-development-india', component: WindowsMobileDevComponent, data: { title:'Windows Mobile Application Development India'} },
  { path: 'custom-core-php-development-india', component: CustomCorePhpDevComponent, data: { title:'Core PHP Development Company including Customized Programming | Veepal'} },
  { path: 'custom-wordpress-development-india', component: CustomWordpressDevComponent, data: { title:'Custom WordPress Development Services Company India | Veepal'} },
  { path: 'custom-magento-development-india', component: CustomMagentoDevComponent, data: { title:'Custom Magento Development Company India | eCommerce Development Services'} },
  { path: 'java-web-development-company-india', component: JavaWebDevComponent, data: { title:'Custom Java Web Development Company India | Hire java developer India'} },
  { path: 'coldfusion-development-india', component: ColdfusionDevComponent, data: { title:'Coldfusion Web Development Company India | Hire ColdFusion Developers'} },
  { path: 'custom-python-odoo-development-india', component: CustomPythonOdooDevComponent, data: { title:'Custom Python Development Company India | Hire Python Developers India'} },
  
  { path: 'hire-codeIgniter-framework-developers-india', component: HireCodeIgniterFrameworkDevComponent, data: { title:'Build Dynamic & Robust Web Apps by CodeIgniter Development | Veepal'} },
  { path: 'hire-laravel-developers-india', component: HireLaravelDevComponent, data: { title:'Custom Laravel Development Company India | Hire Laravel Developers'} },
  { path: 'hire-ms-dynamics-developers-programmers', component: DynamicsCrmComponent, data: { title:'Hire Microsoft dynamics developers India'} },
  { path: 'hire-full-mean-stack-developers-india', component: HireFullMeanStackDevComponent, data: { title:'MEAN Stack Application Development Company India | Hire MEAN Stack Developers India'} },
  { path: 'hire-lamp-stack-developers-india', component: HireLampStackDevComponent, data: { title:'LAMP Stack Application Development Company India | Hire LAMP Stack Developers India'} },
  { path: 'hire-odoo-developers-programmers', component: HireOdooDevComponent, data: { title:'Hire Odoo developers India'} },
  { path: 'hire-ms-dynamics-developers-programmers', component: HireMsDynamicsDevComponent, data: { title:'Hire Microsoft dynamics developers India'} },
  { path: 'hire-microsoft-dotnet-developers-programmers', component: HireMicrosoftDotnetDevComponent, data: { title:'Hire Asp.net Developer India'} },
  { path: 'hire-wordpress-developers-programmers', component: HireWordpressDevComponent, data: { title:'Hire Wordpress Developer India'} },
  { path: 'hire-magento-developers-programmers', component: HireMagentoDevComponent, data: { title:'Hire Magento Developer India'} },
  { path: 'hire-ios-apps-developers-programmers', component: HireIosAppsDevComponent, data: { title:'Hire iPhone Developer India'} },
  { path: 'hire-android-app-developers-programmers', component: HireAndroidAppDevComponent, data: { title:'Hire Android Developer India'} },
  { path: 'hire-joomla-developers-programmers', component: HireJoomlaDevComponent, data: { title:'Hire Joomla Developer India'} },
  { path: 'hire-seo-managers', component: HireSeoManagersComponent, data: { title:'Hire SEO Professional Expert India'} },
  { path: 'hire-php-developers-programmers', component: HirePhpDevComponent, data: { title:'Hire PHP Developer India'} },
  
  { path: 'salesforce-crm-development', component: SalesforceCrmDevComponent, data: { title:'Salesforce CRM Development Company India | Veepal IT Services'} },
  { path: 'sage-crm-development', component: SageCrmDevComponent, data: { title:'Sage CRM - Business Solutions | Sage CRM integration & Development'} },
  { path: 'vtiger-crm-development', component: VtigerCrmDevComponent, data: { title:'Vtiger CRM Development, Vtiger Custom Module Developer | Veepal'} },
  { path: 'sugar-crm-development', component: SugarCrmDevComponent, data: { title:'SugarCRM Integration & Development | SugerCRM Maintenance and Support'} },
  { path: 'ios-development-india', component: IosDevComponent, data: { title:'iPhone App Development Company India'} },  
  { path: 'android-development-india', component: AndroidDevComponent, data: { title:'Android App Development Company India'} },  

  { path: 'aboutus', component: AboutusComponent, data: { title:'About Us'} },  
  { path: 'company-overview', component: CompanyOverviewComponent, data: { title:'Company Overview'} },  
  { path: 'offshore-development-team', component: OffshoreDevComponent, data: { title:'Offshore Development Team'} },  
  { path: 'partnering-offshore-development-company', component: PartneringOffshoreDevComponent, data: { title:'Partnering Offshore Development Company'} },  
  { path: 'careers', component: CareersComponent, data: { title:'Careers'} },  
  { path: 'organizational-values', component: OrganizationalValuesComponent, data: { title:'Organizational Values | Veepal.com'} },  
  { path: 'contact-us', component: ContactUsComponent, data: { title:'Organizational Values | Veepal.com'} }, 
  
  //Product
  { path: 'tracenow-mobile-app', component: TracenowMobileAppComponent, data: { title : "TraceNow | Our Product " }  },
  { path: 'qrush-mobile-app', component: QrushMobileAppComponent, data: { title : "Qrush | Our Product " }  },
  
  //Resource
  { path: 'why-outsource-offshore', component: WhyOutsourceOffshoreComponent, data: { title : "Why Outsource Offshore?" }  },
  { path: 'cto-for-startups', component: CtoForStartupsComponent, data: { title : "CTO Services For Startups" }  },
  { path: 'how-we-work', component: HowWeWorkComponent, data: { title : "How We Work" }  },
  { path: 'engagement-models', component: EngagementModelsComponent, data: { title : "Engagement Models" }  },
  { path: 'clients-feedback-testimonials', component: ClientsFeedbackTestimonialsComponent, data: { title : "Testimonials" }  },
  { path: 'case-studies', component: CaseStudiesComponent, data: { title : "Case Studies" }  },

  // Case Studies
  { path: 'latw', component: LatwComponent, data: { title : "LATW Case Study" }  },
  { path: 'triptiva', component: TriptivaComponent, data: { title : "Triptiva Case Study" }  },
  { path: 'iRemotePay', component: IRemotePayComponent, data: { title : "iRemotePay Case Study" }  },
  { path: 'odoo_pos_development', component: OdooPosDevComponent, data: { title : "Odoo POS Development Case Study" }  },
  { path: 'metawalls', component: MetawallsComponent, data: { title : "Metawalls Case Study" }  },
  { path: 'coacherr', component: CoacherrComponent, data: { title : "Coacherr Case Study" }  },

  { path: 'clients-feedback-testimonials', component: TestimonialsComponent, data: { title : "Testimonials" }  },
  { path: 'ui-ux', component: UiUxComponent, data: { title : "Coacherr Case Study" }  },

  { path: 'error', component:ErrorComponent, data: { title:'Server Not Responding | Veepal.com'}},
  { path: 'inquire-now', component:InquireNowComponent, data: { title:'Inquire Now | Veepal.com'}},
  { path: 'contact-inquiry', component:ContactInquiryComponent, data: { title:'Contact Inquiry | Veepal.com'}},
  //404
  { path: '**', component:PagenotfoundComponent, data: { title:'Page Not Found'}}
];

@NgModule({
  declarations: [
    AppComponent,
    
    HomeComponent,
    HeadMenuComponent,
    FooterComponent,
    ClientLogoComponent,
    CommonScriptComponent,
    
    //services
    MobileAppDevComponent,
    IphoneAppDevComponent,
    ClientLogoComponent,
    CommonScriptComponent,
    IpadAppDevComponent,
    AndroidAppDevComponent,
    WindowAppDevComponent,
    EnterpriseSolutionsComponent,
   
    UiUxDesignServicesComponent,
    CmsWebDevComponent,
    WebApplicationDevComponent,
    EcommerceDevComponent,
    CloudInfrastructureComponent,
    DatabaseDesignDevComponent,
    QualityAssuranceTestingComponent,
    DigitalMarketingAgencyComponent,
    CustomSoftwareDevComponent,
    

    

    //Technologies
    DotnetDevComponent,
    PagenotfoundComponent,
    SharepointDevComponent,
    DotnetNukeDevComponent,
    DynamicsCrmComponent,
    WindowsMobileDevComponent,
    HireLaravelDevComponent,
    CustomCorePhpDevComponent,
    HireCodeIgniterFrameworkDevComponent,
    CustomWordpressDevComponent,
    CustomMagentoDevComponent,
    JavaWebDevComponent,
    ColdfusionDevComponent,
    CustomPythonOdooDevComponent,
    HireFullMeanStackDevComponent,
    HireLampStackDevComponent,
    HireOdooDevComponent,
    SalesforceCrmDevComponent,
    SageCrmDevComponent,
    VtigerCrmDevComponent,
    SugarCrmDevComponent,
    HireMsDynamicsDevComponent,
    IosDevComponent,
    AndroidDevComponent,
    AboutusComponent,
    CompanyOverviewComponent,
    OffshoreDevComponent,
    PartneringOffshoreDevComponent,
    CareersComponent,
    OrganizationalValuesComponent,
    ContactUsComponent,

    //Prdouct
    TracenowMobileAppComponent,
    QrushMobileAppComponent,
    WhyOutsourceOffshoreComponent,
    CtoForStartupsComponent,
    HowWeWorkComponent,
    EngagementModelsComponent,
    ClientsFeedbackTestimonialsComponent,
    CaseStudiesComponent,
    LatwComponent,
    TriptivaComponent,
    IRemotePayComponent,
    OdooPosDevComponent,
    MetawallsComponent,
    CoacherrComponent,
    UiUxComponent,
    HireMicrosoftDotnetDevComponent,
    HireWordpressDevComponent,
    HireMagentoDevComponent,
    HireIosAppsDevComponent,
    HireAndroidAppDevComponent,
    HireJoomlaDevComponent,
    HireSeoManagersComponent,
    HirePhpDevComponent,
    PopupInquiryComponent,
    ErrorComponent,
    InquireNowComponent,
    ContactInquiryComponent,
    TestimonialsComponent
    
   
  ],
  imports: [
    HttpModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [
    CommonScriptComponent,
    GeneralService,
    DataService,
    HttpModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  
}





// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/app.module.ts